module.exports = __webpack_public_path__ + "static/media/qa.b7f04f83.svg";